export default __webpack_public_path__ + "static/media/BTC.eecdd087.svg";